if (!customElements.get('grid-view-toggle')) {
  customElements.define(
    'grid-view-toggle',
    class GridViewToggle extends HTMLElement {
      static STORAGE_KEY = 'opera:collection-view';

      constructor() {
        super();
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-view-label]');
        this.view = this.readStored() || 'grid';

        if (this.button) this.button.addEventListener('click', this.toggle.bind(this));

        // Filtering swaps out the grid markup, which drops the class —
        // re-apply the chosen view after each update.
        const container = document.getElementById('ProductGridContainer');
        if (container) {
          new MutationObserver(() => this.apply()).observe(container, { childList: true, subtree: true });
        }

        this.apply();
      }

      readStored() {
        try {
          const value = localStorage.getItem(GridViewToggle.STORAGE_KEY);
          // 'list' is the old name for what is now the gallery view.
          if (value === 'list' || value === 'gallery') return 'gallery';
          return value === 'grid' ? 'grid' : null;
        } catch (e) {
          return null;
        }
      }

      store(value) {
        try {
          localStorage.setItem(GridViewToggle.STORAGE_KEY, value);
        } catch (e) {
          // Private browsing or blocked storage — the view still works, it just won't persist.
        }
      }

      toggle() {
        this.view = this.view === 'gallery' ? 'grid' : 'gallery';
        this.store(this.view);
        this.apply();
      }

      apply() {
        const isGallery = this.view === 'gallery';
        // The empty state reuses the #product-grid id on a plain div; only the
        // product list itself may take the gallery class.
        const grid = document.getElementById('product-grid');
        if (grid && grid.classList.contains('product-grid')) {
          grid.classList.toggle('product-grid--gallery', isGallery);
          // The tile link is display:none in grid view; keep it out of the tab
          // order there and restore it when the gallery shows it.
          grid.querySelectorAll('.product-grid__gallery-link').forEach((link) => {
            if (isGallery) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', '-1');
          });
        }

        if (this.button) {
          this.button.setAttribute('aria-pressed', isGallery ? 'true' : 'false');
          // Announce what the button will switch TO, which is what a label should say.
          const next = isGallery ? this.dataset.gridLabel : this.dataset.galleryLabel;
          if (next) this.button.setAttribute('aria-label', next);
        }
        if (this.label) {
          this.label.textContent = isGallery ? this.dataset.galleryText : this.dataset.gridText;
        }
      }
    }
  );
}
